export const ZINDEX_BACKGROUND = 0
export const ZINDEX_CANVAS = 990
export const ZINDEX_GARLANDS = 995
export const ZINDEX_SNOWFLAKES = 999
